
























































































import { Component, Mixins, Prop } from "vue-property-decorator";

// Mixins
import SelectMappingInjectorMixin from "@/mixins/selectMappingInjectorMixin";

@Component({
  components: {
    "select-mapping-list-item": () =>
      import("@/components/app/admin/imports/selectMappingListItem.vue")
  }
})
export default class SelectMappingListing extends Mixins(
  SelectMappingInjectorMixin
) {
  // Props

  @Prop({ default: null })
  public selectedId!: string | null;

  @Prop({ default: false })
  public showMedia!: boolean;

  // Data

  public isProcessing: string[] = [];

  // Methods

  public onSelect(id) {
    this.isProcessing.push(id);
    this.$emit("select", id);
  }

  // Computed

  public get skeletonSize() {
    const { data } = this.$selectMappingData.table;
    if (data.length) return data.length;

    return this.$store.getters["ui/isMobile"] ? 2 : 5;
  }

  public get showEmptyState() {
    return (
      !this.$selectMappingData.isLoading &&
      !this.$selectMappingData.table.data.length
    );
  }

  public get showSkeletons() {
    return this.$selectMappingData.isLoading || !this.$selectMappingData.total;
  }
}
